// Vendor
import * as React from 'react';

// Internal
import { Image } from '@src/components/Image/Image';
import { DEFAULT_SAL_PROPS } from '@src/config/sal';

const StuckAtHome: React.FC = () => {
  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS} className="max-w-xl">
        Online Resale Fills Void for Stuck-at-Home Value Seekers
      </h1>

      <p
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={50}
        className="tup-body max-w-lg"
      >
        thredUP activity accelerated in April and May, as shoppers found value
        and entertainment in thrifting.
      </p>

      <div className="flex flex-wrap">
        <div
          {...DEFAULT_SAL_PROPS}
          data-sal="fade"
          data-sal-delay={100}
          className="md:mr-32 mb-8 md:mb-0"
        >
          <h2>A Quarantine Clean Out Frenzy</h2>
          <Image
            {...DEFAULT_SAL_PROPS}
            alt="Thredup Cleanout Bag"
            fileName="1d-cleanout-photo.jpg"
            maxWidth={356}
          />
          <div className="flex justify-around">
            <p className="mr-8" style={{ maxWidth: 170 }}>
              <span className="tup-number font-bold">50%</span>
              <br />
              of people are cleaning out their closets more than they were
              pre-Covid.<sup>2</sup>
            </p>
            <p style={{ maxWidth: 170 }}>
              <span className="tup-number font-bold">6.5X</span>
              <br />
              more Donation Clean Out Kits ordered in April compared to prior
              months.<sup>8</sup>
            </p>
          </div>
        </div>
        <div {...DEFAULT_SAL_PROPS} data-sal="fade" data-sal-delay={250}>
          <h2>Thrift Shopping as Affordable Fun</h2>
          <Image
            {...DEFAULT_SAL_PROPS}
            alt="Thredup Goody Box"
            fileName="1d-box-photo.jpg"
            maxWidth={356}
          />
          <div className="flex justify-around">
            <p className="mr-8" style={{ maxWidth: 170 }}>
              <span className="tup-number font-bold">2.2M hrs</span>
              <br />
              spent by shoppers browsing thredUP in May— a <b>31%</b> increase
              post-Covid.<sup>8</sup>
            </p>
            <p style={{ maxWidth: 190 }}>
              <span className="tup-number font-bold">May 2020</span>
              <br />
              was a record-breaking month for new thredUP visits.<sup>8</sup>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export { StuckAtHome };
